module.exports = __webpack_public_path__ + "img/load-empty-img1.9fdd66d1.png";